 /* @ngInject */
export default class TrusteeDashboardCtrl {
    constructor(
        $sce,
        $scope,
        $timeout,
        $rootScope,
        BuildingsService,
        NavigationService,
        LocalStorageService,
        DashboardService,
    ) {
        this.$sce = $sce;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.BuildingsService = BuildingsService;
        this.NavigationService = NavigationService;
        this.LocalStorageService = LocalStorageService;
        this.DashboardService = DashboardService;

        this.init();
        this.activate();
    }

    async init() {
        this.isBusy = true;
    }
}